import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class MigrationReusableService {
	refreshCompletedMigrations$: Subject<boolean>;

	constructor() {
		this.refreshCompletedMigrations$ = new Subject<boolean>();
	}

	/**
	 * Load new migrations to completed migrations list and notify that new migration is compiled.
	 */
	refreshCompletedResults() {
		return this.refreshCompletedMigrations$.next(true);
	}
}
